import _classCallCheck from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { array, isString } from 'vega-util';
import * as log from '../../log';
import { isLookupData, isLookupSelection } from '../../transform';
import { duplicate, hash as _hash, varName } from '../../util';
import { DataFlowNode, OutputNode } from './dataflow';
import { findSource } from './parse';
import { SourceNode } from './source';
import { DataSourceType } from '../../data';
export var LookupNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(LookupNode, _DataFlowNode);

  var _super = _createSuper(LookupNode);

  function LookupNode(parent, transform, secondary) {
    var _this;

    _classCallCheck(this, LookupNode);

    _this = _super.call(this, parent);
    _this.transform = transform;
    _this.secondary = secondary;
    return _this;
  }

  _createClass(LookupNode, [{
    key: "clone",
    value: function clone() {
      return new LookupNode(null, duplicate(this.transform), this.secondary);
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set([this.transform.lookup]);
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(this.transform.as ? array(this.transform.as) : this.transform.from.fields);
    }
  }, {
    key: "hash",
    value: function hash() {
      return "Lookup ".concat(_hash({
        transform: this.transform,
        secondary: this.secondary
      }));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var foreign;

      if (this.transform.from.fields) {
        // lookup a few fields and add create a flat output
        foreign = Object.assign({
          values: this.transform.from.fields
        }, this.transform.as ? {
          as: array(this.transform.as)
        } : {});
      } else {
        // lookup full record and nest it
        var asName = this.transform.as;

        if (!isString(asName)) {
          log.warn(log.message.NO_FIELDS_NEEDS_AS);
          asName = '_lookup';
        }

        foreign = {
          as: [asName]
        };
      }

      return Object.assign(Object.assign({
        type: 'lookup',
        from: this.secondary,
        key: this.transform.from.key,
        fields: [this.transform.lookup]
      }, foreign), this.transform.default ? {
        default: this.transform.default
      } : {});
    }
  }], [{
    key: "make",
    value: function make(parent, model, transform, counter) {
      var sources = model.component.data.sources;
      var _transform = transform,
          from = _transform.from;
      var fromOutputNode = null;

      if (isLookupData(from)) {
        var fromSource = findSource(from.data, sources);

        if (!fromSource) {
          fromSource = new SourceNode(from.data);
          sources.push(fromSource);
        }

        var fromOutputName = model.getName("lookup_".concat(counter));
        fromOutputNode = new OutputNode(fromSource, fromOutputName, DataSourceType.Lookup, model.component.data.outputNodeRefCounts);
        model.component.data.outputNodes[fromOutputName] = fromOutputNode;
      } else if (isLookupSelection(from)) {
        var selName = from.selection;
        transform = Object.assign({
          as: selName
        }, transform);
        fromOutputNode = model.getSelectionComponent(varName(selName), selName).materialized;

        if (!fromOutputNode) {
          throw new Error(log.message.noSameUnitLookup(selName));
        }
      }

      return new LookupNode(parent, transform, fromOutputNode.getSource());
    }
  }]);

  return LookupNode;
}(DataFlowNode);